import { useTranslation } from 'react-i18next';

import { AppHeader } from '@sternum/web/components';
import { namespaces } from '@sternum/web/services/i18n';

export function Header() {
  const { t } = useTranslation(namespaces.integrations);

  return (
    <AppHeader>
      <AppHeader.Section>
        <AppHeader.Title>{t('integrations')}</AppHeader.Title>
      </AppHeader.Section>
    </AppHeader>
  );
}
